(function () {
  var started = false;
  var completed = false;
  var questionCount = 0;
  function publish(name, details) {
    try {
      if (!window.Shopify || !Shopify.analytics) return;
      var pending = Shopify.analytics.publish('voux:' + name, details);
      if (pending && pending.catch) pending.catch(function () {});
      if (typeof window.gtag === 'function' && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        var params = Object.assign({send_to: 'G-PY0D83YMNF', page_location: location.origin + location.pathname}, details);
        window.gtag('event', name, params);
      }
    } catch (error) {}
  }
  function init() {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      var host = document.getElementById('app-embed-container-891575');
      if (!host || !host.shadowRoot) {
        if (attempts >= 120) clearInterval(timer);
        return;
      }
      clearInterval(timer);
      var root = host.shadowRoot;
      var formSeen = !!root.querySelector('form[data-testid="form"]');
      var recorded = false;
      new MutationObserver(function () {
        if (root.querySelector('form[data-testid="form"]')) formSeen = true;
        var success = root.querySelector('[data-current-step="success"]');
        if (formSeen && !recorded && !root.querySelector('form[data-testid="form"]') && success) {
          recorded = true;
          publish('popup_signup', {form_id: '891575'});
        }
      }).observe(root, {childList: true, subtree: true});
    }, 500);
    if (location.pathname !== '/pages/find-your-ampoule') return;
    var questions = document.getElementById('q-wrap');
    var result = document.getElementById('result-wrap');
    if (!questions || !result) return;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button) return;
      if (button.id === 'restart') {
        started = false;
        completed = false;
        questionCount = 0;
        return;
      }
      if (!questions.contains(button)) return;
      if (!started) {
        started = true;
        publish('quiz_start', {quiz_id: 'find_your_ampoule'});
      }
      questionCount += 1;
      publish('quiz_progress', {quiz_id: 'find_your_ampoule', question_number: questionCount});
    }, true);
    new MutationObserver(function () {
      if (!started || completed || !result.querySelector('a[href*="/products/"]')) return;
      completed = true;
      publish('quiz_complete', {quiz_id: 'find_your_ampoule', questions_answered: questionCount});
    }).observe(result, {childList: true, subtree: true});
    result.addEventListener('click', function (event) {
      if (event.target.closest('a[href*="/products/"]')) {
        publish('quiz_product_click', {quiz_id: 'find_your_ampoule'});
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
